export const MAX_INPUT_CHARS = 64
export const LARGE_LABEL_THRESHOLD = 10
export const CALL_DEBOUNCE_MS = 300
export const LONG_INPUT_TEXT_THRESHOLD = 36
export const MAX_NUM_OF_PLAYERS = 3
